module.exports = __webpack_public_path__ + "img/labels-3-d-desktop-fr.a57d186f.webp";